<template>
  <div class="indexAbout">
    <img src="../../assets/bottom_about_1.png" class="aboutPic_1" />
    <img src="../../assets/bottom_about_2.png" class="aboutPic_2" />
    <img src="../../assets/bottom_about_3.png" class="aboutPic_3" />
    <img src="../../assets/bottom_about_4.png" class="aboutPic_4" />
    <h6>关于青新学吧</h6>
    <p>
      “青新学吧”教师个性化培训平台资源优势明显，其隶属于青岛日报报业集团最强互联网媒体青岛新闻网络传播有限公司，是青岛市教育行政部门批准的专业教师培训平台。依托报业集团、青岛新闻网优势，平台专注于积聚社会办学机构教学力量，集合丰富课程资源如全国范围名师名校长资源，学科教师课程标准、教师基本技能、传统文化、教育技术、媒体素养及综合类课程等师资培训，聚焦原创和分享的课程内容制作、集成和发布为一体，打造智能化教师培训多媒体平台，发挥独家具备的媒体优势，赋能平台开放共享互动发展的媒体属性，赋能机构创新、创造、创意的市场属性，赋能教师学员成长发展的个性化属性。
    </p>
    <router-link to="/about" class="aboutMore" target="_blank">了解更多&nbsp;&nbsp;›</router-link>
  </div>
</template>

<style scoped>
.indexAbout {
  width: 100%;
  height: 300px;
  min-width: 1200px;
  background: url(../../assets/bottom_about_bg.png);
  background-size: 100% 100%;
  padding-top: 60px;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.aboutPic_1 {
  display: block;
  position: absolute;
  z-index: -1;
  width: 200px;
  height: 165px;
  top: 115px;
  left: 145px;
}
.aboutPic_2 {
  display: block;
  position: absolute;
  z-index: -1;
  width: 131px;
  height: 106px;
  top: 144px;
  left: 371px;
}
.aboutPic_3 {
  display: block;
  position: absolute;
  z-index: -1;
  width: 68px;
  height: 68px;
  top: 46px;
  left: 467px;
}
.aboutPic_4 {
  display: block;
  position: absolute;
  z-index: -1;
  width: 318px;
  height: 334px;
  top: -34px;
  right: 360px;
}
h6 {
  display: block;
  width: 820px;
  margin: 0 auto;
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}
p {
  display: block;
  width: 820px;
  margin: 0 auto;
  color: #fff;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  text-indent: 2em;
  margin-bottom: 20px;
}
.aboutMore {
  display: block;
  color: #f1c628;
  text-align: center;
  font-size: 18px;
}
.aboutMore:hover {
  text-decoration: underline;
}
</style>